import { Box, chakra, LinkBox, LinkOverlay, Text } from "@chakra-ui/react";
import { CardProps } from "../card";
import DownloadIcon from "@/components/svg/DownloadIcon";
import { ClientEnvironmentContext } from "@/utils/globalConfig/clientEnvironmentContext";
import { useContext } from "react";

export default chakra(DownloadLinks);
function DownloadLinks({ downloads }: { downloads: CardProps[] }) {
  const clientEnvironment = useContext(ClientEnvironmentContext);
  const umbracoBaseUrl = clientEnvironment!.umbracoBaseUrl;

  const getFileExtension = (url?: string) => {
    if (!url) return "";

    return (
      url.split("?")[0].split("#")[0].split(".").pop()?.toUpperCase() ?? ""
    );
  };

  return (
    <Box display="flex" flexDirection="column" gap={5}>
      {downloads &&
        downloads.map((download, index) => (
          <LinkBox
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={2}
            px={10}
            py={5}
            borderRadius="2xl"
            borderBottomWidth="2px"
            borderBottomColor="brand.aubergine"
            backgroundColor="brand.grey"
            //--index as key is accepted, list is static--//
            key={index}
          >
            <Box>
              <Text color="brand.cyan" textStyle="display.x4s">
                {getFileExtension(download.link?.url)}
              </Text>
              <LinkOverlay
                href={
                  download?.link?.url
                    ? umbracoBaseUrl + download.link.url
                    : undefined
                }
                download
                color="brand.aubergine"
                textStyle="label.lg"
                wordBreak="break-word"
                _hover={{ textDecoration: "none" }}
              >
                {download.title}
              </LinkOverlay>
            </Box>
            <Box flexShrink={0}>
              <DownloadIcon />
            </Box>
          </LinkBox>
        ))}
    </Box>
  );
}
